<template>
  <div class="access-record-container">
    <!--主页面 -->
    <div class="flex-row" style="height: 100%">
      <div class="flex-auto flex-valign" style="overflow: hidden">
        <!-- 右侧表格 -->
        <div class="section-main_table" style="flex-direction: column">
          <!-- 查询条件 -->
          <div class="query">
            <el-form
              style="margin-top: 10px; transition: all 200ms"
              :class="showSearch ? 'expand searchContent' : 'up searchContent'"
              :inline="true"
              ref="search-form"
              label-position="right"
              label-width="90px"
              :model="searchForm"
            >
              <el-form-item label="数据来源">
                <el-select
                  v-model="searchForm.dataSource"
                  placeholder="请选择"
                  style="width: 200px"
                >
                  <el-option
                    v-for="item in dataSourceOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="客户">
                <el-input
                  v-model="searchForm.custom"
                  style="width: 200px"
                ></el-input>
              </el-form-item>
              <!-- <el-form-item label="司机姓名">
                <el-input
                  v-model="searchForm.driverName"
                  style="width: 200px"
                ></el-input>
              </el-form-item> -->
              <el-form-item label="前车车牌">
                <el-input
                  v-model="searchForm.frontPlate"
                  style="width: 200px"
                />
              </el-form-item>
              <el-form-item label="柜号">
                <el-input
                  v-model="searchForm.cabinetNumber"
                  style="width: 200px"
                />
              </el-form-item>
              <!-- <el-form-item label="手机号">
                <el-input v-model="searchForm.phone" style="width: 200px" />
              </el-form-item> -->
              <div>
                <el-form-item label="作业类型">
                  <el-select
                    v-model="searchForm.operateType"
                    placeholder="请选择"
                    style="width: 200px"
                  >
                    <el-option
                      v-for="item in zyTypeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <!-- <el-form-item
                  label="操作类型"
                  v-if="searchForm.operateType == '3'"
                >
                  <el-select
                    v-model="searchForm.passType"
                    placeholder="请选择"
                    style="width: 200px"
                  >
                    <el-option
                      v-for="item in czTypeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item> -->
                <!-- <el-form-item label="预约日期">
                  <el-date-picker
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择预约日期"
                    v-model="searchForm.estimatedArrivalTime"
                    style="width: 300px"
                  ></el-date-picker>
                </el-form-item> -->
              </div>
            </el-form>

            <div>
              <el-button type="primary" @click="searchResult">查询 </el-button>
              <el-button type="info" @click="resetQuery">重置 </el-button>
              <el-button
                type="text"
                size="medium"
                v-show="showExpandBtn"
                @click="showSearch = !showSearch"
                :icon="showSearch ? 'el-icon-arrow-up ' : 'el-icon-arrow-down'"
                style="color: #407aee"
                >{{ !showSearch ? "展开" : "收起" }}
              </el-button>
            </div>
          </div>

          <div style="display: grid; height: 0; flex: 1">
            <ioc-table
              ref="crud"
              :data="tableData"
              :option="option"
              :page="page"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            >
              <template slot="menuLeft">
                <el-button
                  type="primary"
                  size="small"
                  class="iss-operation-button"
                  icon="el-icon-plus"
                  @click="handleBatchImport"
                >
                  批量导入
                </el-button>
                <el-button
                  type="primary"
                  size="small"
                  class="iss-operation-button"
                  icon="iconfont icon-xiugai"
                  @click="handleTextParsing"
                >
                  文本解析
                </el-button>
                <el-button
                  type="primary"
                  size="small"
                  class="iss-operation-button"
                  icon="el-icon-plus"
                  @click="handleOcrRecognize"
                >
                  OCR识别
                </el-button>
              </template>
              <!-- 状态 -->
              <!-- <template slot="appointmentStatus" slot-scope="scope">
                <span>{{ initStatusOps(scope.row.appointmentStatus) }}</span>
              </template> -->
              <template slot="menu" slot-scope="scope">
                <el-tooltip
                  v-if="
                    scope.row.appointmentStatus == '1' &&
                    scope.row.dataSource == '1'
                  "
                  class="item"
                  effect="dark"
                  content="编辑"
                  placement="top"
                  popper-class="tooltip-draw"
                >
                  <el-button
                    type="text"
                    icon="iconfont icon-xiugai"
                    @click="handleEdit(scope.row, scope.index)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  v-if="
                    scope.row.appointmentStatus == '1' &&
                    scope.row.dataSource == '1'
                  "
                  class="item"
                  effect="dark"
                  content="删除"
                  placement="top"
                  popper-class="tooltip-draw"
                >
                  <el-button
                    type="text"
                    icon="iconfont icon-shanchu"
                    @click="handleDel(scope.row, scope.index)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="详情"
                  placement="top"
                  popper-class="tooltip-draw"
                >
                  <el-button
                    type="text"
                    icon="iconfont icon-Detail"
                    @click="handleView(scope.row, scope.index)"
                  ></el-button>
                </el-tooltip>
              </template>
            </ioc-table>
          </div>
        </div>
      </div>
    </div>

    <!-- 编辑/详情 客服录入 -->
    <appPanel
      :width="pageStates == 'view' ? 700 : 840"
      class="app-panel"
      :isExpand="showEntryPanel"
      :title="pageStates == 'edit' ? '编辑客服录入' : '客服录入详情'"
      @cancel="handleCloseEntryPanel"
    >
      <entryPanel
        ref="refEntryPanel"
        :pageStates="pageStates"
        @save-entry-info="saveEntryInfo"
      />

      <span slot="footer" class="dialog-footer">
        <el-button
          @click="handleCloseEntryPanel"
          type="info"
          :loading="subLoading"
          >{{ pageStates == "view" ? "关闭" : "取消" }}</el-button
        >
        <el-button
          v-if="pageStates != 'view'"
          type="primary"
          :loading="subLoading"
          @click="handleSaveEntryPanel"
        >
          {{ subLoading ? "提交中" : "确定" }}
        </el-button>
      </span>
    </appPanel>

    <!-- 批量导入 -->
    <appPanel
      :width="840"
      class="app-panel"
      :isExpand="showImportPanel"
      title="批量导入"
      @cancel="handleCloseImportPanel"
    >
      <importPanel
        ref="refImportPanel"
        @save-import-info="handleCheckOpt"
      ></importPanel>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleConfirmImportPanel"
          >确定</el-button
        >
        <el-button @click="handleCloseImportPanel" type="info">关闭</el-button>
      </span>
    </appPanel>
    <!-- 文本解析 -->
    <appPanel
      :width="840"
      class="app-panel"
      :isExpand="showTextPanel"
      title="文本解析"
      @cancel="handleCloseTextPanel"
    >
      <textPanel
        ref="refTextPanel"
        @save-text-info="refreshEntryInfo"
      ></textPanel>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseTextPanel" type="info">关闭</el-button>
      </span>
    </appPanel>
    <!-- OCR识别 -->
    <appPanel
      :width="840"
      class="app-panel"
      :isExpand="showRecognizePanel"
      title="OCR识别"
      @cancel="handleCloseRecognizePanel"
    >
      <recognizePanel
        ref="refRecognizePanel"
        @save-recognize-info="refreshEntryInfo"
      ></recognizePanel>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseRecognizePanel" type="info"
          >关闭</el-button
        >
      </span>
    </appPanel>
  </div>
</template>
<script>
import { api } from "../api";
import entryPanel from "../components/entryPanel";
import importPanel from "../components/importPanel";
import textPanel from "../components/textPanel";
import recognizePanel from "../components/recognizePanel";
import tableOption from "../const/crud/entry.js";
import utils from "@src/common/utils";
import { Bus, Dates } from "$utils";
import appPanel from "@src/components/business/app-panel/index";
export default {
  components: {
    entryPanel,
    importPanel,
    textPanel,
    recognizePanel,
    appPanel,
  },
  data() {
    return {
      pageStates: "edit",
      // 搜索条件
      searchForm: {
        dataSource: "", // 数据来源
        cabinetNumber: "", // 柜号
        operateType: null, // 作业类型
        custom: "", // 客户
        frontPlate: "", // 车牌号
        passType: null, // 操作类型
        estimatedArrivalTime: null, // 预约日期
      },
      // 选择的作业类型
      selectedType: [],
      zyTypeOptions: [
        {
          label: "装货",
          value: "1",
        },
        {
          label: "卸货",
          value: "2",
        },
        {
          label: "过车",
          value: "3",
        },
      ],
      // 选择的操作类型
      selectedOperateType: [],
      czTypeOptions: [
        {
          label: "倒入",
          value: "1",
        },
        {
          label: "倒出",
          value: "2",
        },
      ],
      dateRange: [],

      showExpandBtn: false,
      showSearch: true,
      dataSourceOptions: [
        {
          label: "客服录入",
          value: "1",
        },
        {
          label: "司机预约",
          value: "0",
        },
      ],
      // 修改/详情录入
      showEntryPanel: false,
      // 批量导入
      showImportPanel: false,
      // 文本解析
      showTextPanel: false,
      // OCR识别
      showRecognizePanel: false,
      searchParams: {},
      loading: true,
      type: "",
      tableData: Object.freeze([]),
      page: {
        pageNum: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_pageSize") || 10,
      },
      option: tableOption(this),
      subLoading: false,
    };
  },
  mounted() {
    this.animation();
    this.getEntryList();
  },
  methods: {
    animation() {
      let that = this;
      let domAry =
        document.querySelector(".searchContent") &&
        document.querySelector(".searchContent").children;
      console.log("--谷峰平--domAry:-", domAry);
      if (!domAry) {
        return;
      }
      window.onresize = function () {
        that.animation();
      };
      if (domAry[domAry.length - 1].offsetTop != domAry[0].offsetTop) {
        console.log("--00--");
        this.showExpandBtn = true;
      } else {
        console.log("--111--");
        this.showExpandBtn = false;
      }
    },
    // 状态枚举值
    initStatusOps(pStatus) {
      if (pStatus == "1") {
        return "已申请";
      } else if (pStatus == "2") {
        return "已审批";
      } else if (pStatus == "3") {
        return "已签到";
      } else if (pStatus == "4") {
        return "已调度";
      } else if (pStatus == "5") {
        return "已进入作业";
      } else if (pStatus == "6") {
        return "已完成作业";
      } else if (pStatus == "8") {
        return "出园客服已审批";
      } else if (pStatus == "9") {
        return "出园调度已审批";
      } else if (pStatus == "10") {
        return "已出园";
      } else if (pStatus == "95") {
        return "异常终止";
      } else if (pStatus == "96") {
        return "已取消";
      } else if (pStatus == "97") {
        return "已拒绝";
      } else if (pStatus == "98") {
        return "已作废";
      } else if (pStatus == "99") {
        return "结束";
      } else {
        return "暂无";
      }
    },
    showNameByStatus(pStatus) {
      if (pStatus == "0") {
        return "已提交（信息不全）";
      } else if (pStatus == "1") {
        return "已申请（待审批）";
      } else if (pStatus == "2") {
        return "已审批（待签到）";
      } else if (pStatus == "3") {
        return "已签到（待调度）";
      } else if (pStatus == "4") {
        return "已调度（待作业）";
      } else if (pStatus == "5") {
        return "作业中";
      } else if (pStatus == "6") {
        return "已完成作业（待申请离场）";
      } else if (pStatus == "7") {
        return "已申请离场--押车中（出园客服待审批）";
      } else if (pStatus == "8") {
        return "出园客服已审批（出园调度待审批）";
      } else if (pStatus == "9") {
        return "出园调度已审批 （待放行出园）";
      } else if (pStatus == "10") {
        return "已出园";
      } else if (pStatus == "11") {
        return "解压放行";
      } else if (pStatus == "95") {
        return "异常终止";
      } else if (pStatus == "96") {
        return "取消预约";
      } else if (pStatus == "97") {
        return "已拒绝";
      } else if (pStatus == "98") {
        return "已作废";
      } else if (pStatus == "99") {
        return "结束";
      } else {
        return "暂无";
      }
    },
    saveEntryInfo(params) {
      this.handleCloseEntryPanel();
      this.getEntryList();
    },
    handleCloseEntryPanel() {
      this.$refs.refEntryPanel.handleRestForm();
      this.showEntryPanel = false;
      // this.$nextTick(() => {
      // });
      // this.$nextTick(() => {
      //   this.$refs.refEntryPanel.$refs.personTable.templateRadio = '';
      // });
    },
    handleSaveEntryPanel() {
      this.$refs.refEntryPanel.submit();
    },
    // 确定--批量倒入弹窗
    handleConfirmImportPanel() {
      // 1.无导入数据
      if (this.$refs.refImportPanel.importRecordObj.total == 0) {
        this.$message({
          message: "请导入数据！",
          type: "warning",
          duration: 2000,
        });
      } else {
        // 2.有导入数据
        // 导入数据成功
        if (this.$refs.refImportPanel.importRecordObj.fail == 0) {
          this.$refs.refImportPanel.getImportSuccessData();
          // this.$confirm(
          //   "您导入的数据没有进行二次核对，确定关闭吗?",
          //   "关闭确认",
          //   {
          //     confirmButtonText: "确认",
          //     cancelButtonText: "取消",
          //     type: "warning",
          //   }
          // )
          //   .then(() => {
          //     this.showImportPanel = false;
          //     // 清除界面数据
          //     this.clearImportInfo();
          //     // 调用入库接口
          //     this.getEntryList();
          //   })
          //   .catch(() => {
          //     this.showImportPanel = false;
          //     // 清除界面数据
          //     this.clearImportInfo();
          //     // 调用入库接口
          //     this.getEntryList();
          //   });
        } else {
          this.$message({
            message: "存在失败数据，导入失败！",
            type: "error",
            duration: 2000,
          });
          this.showImportPanel = false;
          // 清除界面数据
          this.clearImportInfo();
          // 调用入库接口
          this.getEntryList();
        }
      }
    },
    // 关闭--批量导入弹窗
    handleCloseImportPanel() {
      this.showImportPanel = false;
      // 清除界面数据
      this.clearImportInfo();
      // 调用入库接口
      this.getEntryList();
    },
    // 清除--批量导入信息
    clearImportInfo() {
      this.$refs.refImportPanel.clearProgressInterval();
      this.$refs.refImportPanel.progressWidth = 0;
      this.$refs.refImportPanel.fileList = [];
      this.$refs.refImportPanel.importRecordObj.date = "";
      this.$refs.refImportPanel.importRecordObj.total = 0;
      this.$refs.refImportPanel.importRecordObj.fail = 0;
      this.$refs.refImportPanel.importRecordObj.success = 0;
      console.log(
        "-clearImportInfo()-width:-",
        this.$refs.refImportPanel.progressWidth
      );
    },
    // 关闭--文本解析弹窗
    handleCloseTextPanel() {
      this.$refs.refTextPanel.handleRestForm();
      this.showTextPanel = false;
    },
    // 关闭--OCR识别弹窗
    handleCloseRecognizePanel() {
      this.$refs.refRecognizePanel.handleRestForm();
      this.showRecognizePanel = false;
    },
    getEntryList() {
      console.log("-获取录入数据-");
      this.$fetch(
        api.import.queryCustomerImportDataPage,
        Object.assign(
          {
            pageNum: this.page.pageNum,
            pageSize: this.page.pageSize,
          },
          this.searchForm
        )
      ).then((response) => {
        if (response.success) {
          this.tableData = response.returnObj
            ? Object.freeze([...response.returnObj.list])
            : [];
          console.log("-this.tableData:-", this.tableData);
          this.page.total = response.returnObj ? response.returnObj.total : 0;
        } else {
          this.$message({
            message: response.msgContent,
            type: "error",
            duration: 2000,
          });
          return;
        }
      });
    },
    // 核对成功操作
    handleCheckOpt() {
      this.showImportPanel = false;
      // 清除界面数据
      this.clearImportInfo();
      // 调用入库接口
      this.getEntryList();
    },
    // 刷新录入数据
    refreshEntryInfo() {
      if (this.showImportPanel) {
        this.showImportPanel = false;
      }
      if (this.showRecognizePanel) {
        this.showRecognizePanel = false;
      }
      this.getEntryList();
    },
    // 查询按钮事件
    searchResult() {
      console.log("---查询--this.searchForm:--", this.searchForm);
      this.page.currentPage = 1;
      this.getEntryList();
    },
    // 重置按钮
    resetQuery() {
      this.dateRange = [];
      this.selectedType = [];
      this.selectedOperateType = [];
      this.searchForm = {
        dataSource: "", // 数据来源
        cabinetNumber: "", // 柜号
        operateType: null, // 作业类型
        custom: "", // 客户
        frontPlate: "", // 车牌号
        passType: null, // 操作类型
        estimatedArrivalTime: null, // 预约日期
      };

      this.getEntryList();
    },
    handleCurrentChange(val) {
      this.page.pageNum = val;
      this.getEntryList();
    },
    handleSizeChange(val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      this.getEntryList();
    },
    // 批量导入操作
    handleBatchImport() {
      this.showImportPanel = true;
      this.$refs.refImportPanel.isChecked = false;
      // 清除界面数据
      this.clearImportInfo();
    },
    // 文本解析操作
    handleTextParsing() {
      this.showTextPanel = true;
      // console.log("-当前时间:-", Dates.format(new Date(), "yyyy/MM/dd"));
      this.$refs.refTextPanel.textInfo.estimatedArrivalTime = Dates.format(
        new Date(),
        "yyyy/MM/dd"
      );
    },
    // OCR识别操作
    handleOcrRecognize() {
      this.showRecognizePanel = true;
      this.$refs.refRecognizePanel.recognizeInfo.estimatedArrivalTime =
        Dates.format(new Date(), "yyyy/MM/dd");
    },
    handleEdit(row, index) {
      console.log("-修改:-", row);
      this.pageStates = "edit";
      this.showEntryPanel = true;
      this.$refs.refEntryPanel.handleSetForm(row);
    },
    handleView(row, index) {
      this.pageStates = "view";
      this.showEntryPanel = true;
      this.$refs.refEntryPanel.handleSetForm(row);
    },
    handleDel(row) {
      console.log("-删除:-", row);
      const params = {
        appointmentUuid: row.appointmentUuid,
        appointmentCabinetCode: row.appointmentCabinetCode,
      };
      this.$confirm("您确定删除信息吗?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.import.deleteCustomerImportData, params).then(
          (response) => {
            if (response && response.success) {
              this.$message({
                message: "删除成功",
                type: "success",
                duration: 2000,
              });
            } else {
              this.$message({
                message: response.msgContent,
                type: "error",
                duration: 2000,
              });
            }
            this.getEntryList();
          }
        );
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";

.el-select {
  width: 100%;
}

.expand {
  width: calc(100% - 250px);
  height: auto;
}

.up {
  width: calc(100% - 250px);
  height: 41px;
  overflow: hidden;
}

.panel-content {
  .content-top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .info-item {
    margin: 15px 0px;
    // width: 50%;
  }

  .item-img {
    margin: 15px 0px;
  }

  .label {
    padding: 0 20px;
    width: 100px;
    text-align: center;
  }

  .detail-info {
    width: 100%;
    padding: 0 40px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    flex-wrap: wrap;
  }
  .img-info-box {
    margin-bottom: 120px;
    position: relative;

    ::v-deep .el-form-item--small.el-form-item {
      margin-bottom: 18px;
      display: flex;
      width: 100%;

      .el-form-item__content {
        flex: 1;
      }
    }
  }
}

.access-record-container {
  width: 100%;
  height: 86vh;

  .query {
    display: flex;
    justify-content: space-between;
    align-items: center;
    @include set_theme_color(background-color, left-menu-bg-color);
    padding: 10px 16px 3px;

    .el-form-item {
      display: inline-block;
      margin-right: 20px;
      margin-bottom: 8px !important;
      vertical-align: top;
    }
  }

  /deep/ .ioc-table {
    width: 100%;
  }
  /deep/ .ioc-table__content {
    padding-top: 15px;
  }
  /deep/ .el-table__body-wrapper {
    width: 100%;
    height: calc(100% - 60px);
    max-height: calc(100% - 60px);
    overflow-y: auto;
  }
  /deep/ .app-side-panel__body {
    overflow-y: auto;
  }
  .el-table__fixed-right-patch {
    display: none;
  }

  .el-dialog {
    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
      width: 260px;
    }
  }
}

.car-info-box {
  margin-bottom: 148px;
  position: relative;

  ::v-deep .el-form-item--small.el-form-item {
    margin-bottom: 18px;
    display: flex;
    width: 100%;

    .el-form-item__content {
      flex: 1;
    }
  }
}
</style>
